import React from "react";
import { Link } from "react-router-dom";

import img1 from "../../../image/Group29.png"

const Signup = () => {
  return (
    <>
      <div className="flex flex-col md:flex-row h-screen w-full">
        {/*Left section */}
        <div className="w-full md:w-1/2 flex items-center justify-center p-8">
          <div className="w-full max-w-md">
            <div className="flex justify-center mb-4">
              <img
                className="h-12"
                src="https://www.newslettrai.com/static/media/favicon-logo.2e38bb3e57b907d138c2.webp"
                alt=""
              />
            </div>
            <h2 className="md:text-[28px] lg:text-[32px] text-[28px] font-semibold text-center text-[#323232]">
              Sign up to Newsletterai
            </h2>
            <p className="text-[#78787880] text-center mb-6 md:text-[14px] text-[12px] mt-1 font-medium leading-none">
              Clarity gives you the blocks and components you <br /> need to
              create a truly professional website.
            </p>
            <form className="space-y-4">
              <div>
                <label className="block text-[#323232] font-semibold text-x">
                  Email Address
                </label>
                <input
                  type="email"
                  className="w-full p-3 border border-[#808080] rounded-lg outline-[#0074D9]"
                />
              </div>
              <div>
                <label className="block text-[#323232] font-semibold text-x">
                  Password
                </label>
                <input
                  type="password"
                  className="w-full p-3 border border-[#808080] rounded-lg outline-[#0074D9]"
                />
              </div>
              <button className="w-full bg-[#323232] text-white p-3 rounded-lg font-semibold">
                Sign up to your Account
              </button>
            </form>

            <div className="flex items-center my-4">
              <hr className="flex-grow border-[#808080] border-[1.5px]" />
              <span className="px-2 text-[#808080] font-semibold">or</span>
              <hr className="flex-grow border-[#808080] border-[1.5px]" />
            </div>

            <button className="w-full flex items-center justify-center bg-[#e8e7e7] p-3 rounded-lg font-semibold text-[#323232]">
              <img
                src="https://www.svgrepo.com/show/355037/google.svg"
                alt="Google"
                className="w-5 h-5 mr-2"
              />
              Continue with Google
            </button>
            <p className="text-center mt-4 text-[#71717A]  text-[14px]">
              Already have an account?{" "}
              <Link to="#" className="text-blue-600 font-semibold">
                Sign in
              </Link>
            </p>
          </div>
        </div>

        {/*Right section */}
        <div className="hidden md:flex flex-col w-1/2 h-screen bg-gray-200 justify-center items-start p-0 m-0 overflow-hidden">
          <div className="flex flex-col justify-center items-center text-left px-6 pt-10">
            <h2 className="text-[28px] font-bold md:text-[25px] lg:text-[32px] text-center text-[#323232]">
              Your All-in-One Platform for{" "}
              <span className="text-[#00BFA6]">Personalized Newsletters</span>
            </h2>
            <p className="text-[#78787880] mt-2 font-semibold leading-none md:text-[14px] text-[12px] text-center">
              Personalize your newsletters, engage readers, and achieve your{" "}
              <br />
              communication goals effortlessly.
            </p>
          </div>

          <div className="w-full flex justify-end items-end">
            <img
              src={img1}
              alt="Newsletter preview"
              className="w-full h-auto object-contain"
              style={{ position: "relative", top: "22px", right: "-23px" }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Signup;
